// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mfa-layout {
  height: 100vh;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 0px;
  background: var(--color-ui-light);
  z-index: 10;
}
.mfa-layout .mfa-container {
  height: max-content;
  width: 100%;
  max-width: 866px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  column-gap: 2.5rem;
  color: var(--color-text-01);
  margin: 0px 2.5rem;
}
@media (max-width: 440px) {
  .mfa-layout .mfa-container {
    margin: 0px 1.5rem;
  }
}
.mfa-layout .mfa-container .mfa-icon-content {
  display: block;
}
.mfa-layout .mfa-container .mfa-icon-content .mfa-phone-icon {
  height: 316px;
  width: 176px;
}
@media (max-width: 562px) {
  .mfa-layout .mfa-container .mfa-icon-content {
    display: none;
  }
}
.mfa-layout .mfa-container .mfa-content {
  height: 100%;
  width: fit-content;
  display: flex;
  flex-direction: column;
  align-items: start;
}
.mfa-layout .mfa-container .mfa-content .mfa-title {
  font-size: 2em;
  font-weight: 300;
  margin-bottom: 1rem;
}
.mfa-layout .mfa-container .mfa-content .mfa-subtitle {
  font-size: 1.17em;
  font-weight: bold;
  white-space: pre-line;
}
.mfa-layout .mfa-container .mfa-content .mfa-description {
  margin-bottom: 2.5rem;
  white-space: pre-line;
}
.mfa-layout .mfa-container .mfa-content .mfa-actions {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: end;
  gap: 1rem;
}
@media (max-width: 440px) {
  .mfa-layout .mfa-container .mfa-content .mfa-actions {
    flex-direction: column-reverse;
    justify-content: center;
    align-items: center;
  }
  .mfa-layout .mfa-container .mfa-content .mfa-actions ::ng-deep cds-button {
    width: 100%;
  }
  .mfa-layout .mfa-container .mfa-content .mfa-actions ::ng-deep cds-button > button {
    width: 100%;
    display: flex;
    justify-content: center;
  }
}

.base-h-tag, .mfa-layout .mfa-container .mfa-content .mfa-title, .mfa-layout .mfa-container .mfa-content .mfa-subtitle {
  display: block;
  margin-left: 0;
  margin-right: 0;
}`, "",{"version":3,"sources":["webpack://./src/app/features/early-mfa/early-mfa.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,QAAA;EACA,iCAAA;EACA,WAAA;AACF;AACE;EACE,mBAAA;EACA,WAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,2BAAA;EACA,kBAAA;AACJ;AACI;EAXF;IAYI,kBAAA;EAEJ;AACF;AAAI;EACE,cAAA;AAEN;AAAM;EACE,aAAA;EACA,YAAA;AAER;AACM;EARF;IASI,aAAA;EAEN;AACF;AACI;EACE,YAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;AACN;AACM;EACE,cAAA;EAEA,gBAAA;EACA,mBAAA;AAAR;AAGM;EACE,iBAAA;EACA,iBAAA;EAEA,qBAAA;AAFR;AAKM;EACE,qBAAA;EACA,qBAAA;AAHR;AAMM;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,oBAAA;EACA,SAAA;AAJR;AAMQ;EAPF;IAQI,8BAAA;IACA,uBAAA;IACA,mBAAA;EAHR;EAKQ;IACE,WAAA;EAHV;EAMQ;IACE,WAAA;IACA,aAAA;IACA,uBAAA;EAJV;AACF;;AAWA;EACE,cAAA;EACA,cAAA;EACA,eAAA;AARF","sourcesContent":[".mfa-layout {\n  height: 100vh;\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  position: absolute;\n  top: 0px;\n  background: var(--color-ui-light);\n  z-index: 10;\n\n  .mfa-container {\n    height: max-content;\n    width: 100%;\n    max-width: 866px;\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    column-gap: 2.5rem;\n    color: var(--color-text-01);\n    margin: 0px 2.5rem;\n\n    @media (max-width: 440px) {\n      margin: 0px 1.5rem;\n    }\n\n    .mfa-icon-content {\n      display: block;\n\n      .mfa-phone-icon {\n        height: 316px;\n        width: 176px;\n      }\n\n      @media (max-width: 562px) {\n        display: none;\n      }\n    }\n\n    .mfa-content {\n      height: 100%;\n      width: fit-content;\n      display: flex;\n      flex-direction: column;\n      align-items: start;\n\n      .mfa-title {\n        font-size: 2em;\n        @extend .base-h-tag;\n        font-weight: 300;\n        margin-bottom: 1rem;\n      }\n\n      .mfa-subtitle {\n        font-size: 1.17em;\n        font-weight: bold;\n        @extend .base-h-tag;\n        white-space: pre-line;\n      }\n\n      .mfa-description {\n        margin-bottom: 2.5rem;\n        white-space: pre-line;\n      }\n\n      .mfa-actions {\n        width: 100%;\n        display: flex;\n        flex-direction: row;\n        justify-content: end;\n        gap: 1rem;\n\n        @media (max-width: 440px) {\n          flex-direction: column-reverse;\n          justify-content: center;\n          align-items: center;\n\n          ::ng-deep cds-button {\n            width: 100%;\n          }\n\n          ::ng-deep cds-button>button {\n            width: 100%;\n            display: flex;\n            justify-content: center;\n          }\n        }\n      }\n    }\n  }\n}\n\n.base-h-tag {\n  display: block;\n  margin-left: 0;\n  margin-right: 0;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
